var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.hasNavigation)?_c('div',{staticClass:"d-flex flex-direction align-center px-4"},[_c('span',{staticClass:"text-h6 font-weight-bold"},[_vm._v(_vm._s(this.viewTitle))]),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }